import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { COLORS } from '@/styles/colorTheme';
import cancel from '@/assets/cancel.svg';
import { cn } from '@/lib/utils';

const Container = styled.div`
  width: 100%;
  background-color: ${COLORS.Background200};
  display: ${(props) => (props.open ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  z-index: 99999;
`;

const ImgWrapper = styled.div`
  position: absolute;
  right: 0px;
  cursor: pointer;
`;

const TextWrapper = styled.div`
  text-align: center;
  margin: 16px;
`;

export default function BetaSubheader({ open, onClose }) {
  const [t] = useTranslation('etc');

  return (
    <div
      className={cn(
        'flex justify-center bg-background-200 items-center z-99999',
        open ? 'flex' : 'hidden',
      )}
    >
      <TextWrapper>
        <div className="text-background-700">
          {t(
            'Server updates may temporarily limit service availability. We appreciate your understanding.',
          )}
        </div>
      </TextWrapper>
      <ImgWrapper onClick={onClose}>
        <img src={cancel} />
      </ImgWrapper>
    </div>
  );
}
